class Logger {
    static log(message, ...details) {
        // eslint-disable-next-line no-console
        console.log(`[LOGGER]`, message, ...details);
    }

    static info(message, ...details) {
        // eslint-disable-next-line no-console
        console.info(`[LOGGER]`, message, ...details);
    }

    static error(message, ...details) {
        // eslint-disable-next-line no-console
        console.error(`[LOGGER]`, message, ...details);
    }

    static warn(message, ...details) {
        // eslint-disable-next-line no-console
        console.warn(`[LOGGER]`, message, ...details);
    }
}

module.exports = Logger;
